export const combineWarehousesAppliances = (warehouses, appliances) => {
  const warehousesObj = warehouses.reduce((acc, rec) => ({ ...acc, [rec.id]: rec }), {});

  const warehousesWithAppliancesObj = appliances.reduce((wh, appliance) => {
    if (wh[appliance.warehouse.id]) {
      return {
        ...wh,
        [appliance.warehouse.id]: {
          ...wh[appliance.warehouse.id],
          appliances: wh[appliance.warehouse.id].appliances ?
            [...wh[appliance.warehouse.id].appliances,
              {
                id: appliance.id,
                label: appliance.label,
                applianceDevices: appliance.applianceDevices }] :
            [{
              id: appliance.id,
              label: appliance.label,
              applianceDevices: appliance.applianceDevices }]
        }
      };
    }
    return wh;
  }, warehousesObj);

  const warehousesWithAppliances = Object.values(warehousesWithAppliancesObj);

  return warehousesWithAppliances;
};
